import { createApiClient } from './client'
import {
  MealResponseDto,
  CreateMealDto,
  UpdateMealDto,
  TripMemberDietaryProfile,
  MealTypeOption,
  DietaryRestrictionOption
} from '@/shared/types'

export class MealsApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  // Get all meals for a trip
  async getTripMeals(tripId: string): Promise<MealResponseDto[]> {
    const response = await this.apiClient.get<MealResponseDto[]>(`/trips/${tripId}/meals`)
    return response
  }

  // Get meal by ID
  async getMealById(mealId: string): Promise<MealResponseDto> {
    const response = await this.apiClient.get<MealResponseDto>(`/meals/${mealId}`)
    return response
  }

  // Create new meal
  async createMeal(tripId: string, mealData: CreateMealDto): Promise<MealResponseDto> {
    const response = await this.apiClient.post<MealResponseDto>(`/trips/${tripId}/meals`, mealData)
    return response
  }

  // Update meal
  async updateMeal(mealId: string, mealData: UpdateMealDto): Promise<MealResponseDto> {
    const response = await this.apiClient.put<MealResponseDto>(`/meals/${mealId}`, mealData)
    return response
  }

  // Delete meal
  async deleteMeal(mealId: string): Promise<void> {
    await this.apiClient.delete(`/meals/${mealId}`)
  }

  // Get meal types
  async getMealTypes(): Promise<MealTypeOption[]> {
    const response = await this.apiClient.get<MealTypeOption[]>('/meal-types')
    return response
  }

  // Get dietary restrictions
  async getDietaryRestrictions(): Promise<DietaryRestrictionOption[]> {
    const response = await this.apiClient.get<DietaryRestrictionOption[]>('/dietary-restrictions')
    return response
  }

  // Dietary Profiles Management
  // Get each member's allergies + dietary restrictions for a trip (from user profiles)
  async getTripDietaryRestrictions(tripId: string): Promise<TripMemberDietaryProfile[]> {
    const response = await this.apiClient.get<TripMemberDietaryProfile[]>(`/trips/${tripId}/dietary-restrictions`)
    return response
  }
}
